<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm v-on:submit.prevent="login">
                  <h1>Tryout Admin</h1>
                  <p class="text-muted">Silahkan masukkan email dan password untuk memulai menggunakan aplikasi</p>
                  <CInput
                    placeholder="Email"
                    autocomplete="username email"
                    v-model="auth.email"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    v-model="auth.password"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton type="submit" color="primary" class="px-4"
                        > <CSpinner size="sm" v-show="loading"/> Masuk </CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
              <CCardFooter>
                <div class="right">{{version}}</div>
              </CCardFooter>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { HTTPAUTH } from "../../lib/httplib";
import { getErrorMessage, setCookie } from "../../lib/helpers";
export default {
  name: "Login",
  data() {
    return {
      auth: {},
      loading: false,
			version: process.env.VUE_APP_VERSION,
    };
  },
  methods: {
    login() {
      if (this.loading) {
        return;
      }
      this.loading = true
      HTTPAUTH.post("/api/v1/auth/login", this.auth)
        .then((res) => {
          this.$toasted.success("Berhasil login").goAway();
          setCookie(res.data);
          location.href = "/";
          this.loading = false
        })
        .catch((eres) => {
      this.loading = false
          this.$toasted.error(getErrorMessage(eres)).goAway();
        });
    },
  },
};
</script>
